import React from 'react';
import './styles.css';

function ComingSoon() {
  return (
    <div className="coming-soon">
      <h1>Coming Soon</h1>
      <p>We are working on something exciting! Stay tuned...</p>
    </div>
  );
}

export default ComingSoon;